document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".collapsible__product__accordion");

  accordions.forEach((accordion) => {
    const detailsElement = accordion.querySelector("details");

    const wasOpen = detailsElement.hasAttribute("open");
    detailsElement.setAttribute("open", "");

    let contentElement = accordion.querySelector(".accordion__content");
    let content = contentElement.innerText;

    let contentDiv = document.createElement("div");
    contentDiv.innerHTML = content;

    contentElement.innerHTML = contentDiv.innerHTML;

    if (!wasOpen) {
      detailsElement.removeAttribute("open");
    }
  });
});
